import { render, staticRenderFns } from "./attendance1.vue?vue&type=template&id=4ef0f234&scoped=true&"
import script from "./attendance1.vue?vue&type=script&lang=js&"
export * from "./attendance1.vue?vue&type=script&lang=js&"
import style0 from "./attendance1.vue?vue&type=style&index=0&id=4ef0f234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef0f234",
  null
  
)

export default component.exports